'use client'

import { useEffect, type ReactNode } from 'react'
import { cx } from './utils/cx'

interface CelebrateCardProps {
  show?: boolean | number
  message?: ReactNode
  sub?: ReactNode
  duration?: number
  onClose?: () => void
  /**
   * 'brutal' (default) is SnapTransfer's own voice. Use 'soft' on white-label
   * surfaces, where the brutalist card would impose our design language on a
   * customer's brand.
   */
  variant?: 'brutal' | 'soft'
}

export function CelebrateCard({
  show,
  message,
  sub,
  duration = 1800,
  onClose,
  variant = 'brutal'
}: CelebrateCardProps) {
  useEffect(() => {
    if (!show || !onClose) return
    const t = setTimeout(onClose, duration)
    return () => clearTimeout(t)
  }, [show, duration, onClose])
  return (
    <div className={cx('st-celebrate', show && 'on')}>
      <div className={cx('st-card-pop', variant === 'soft' && 'st-card-pop--soft')}>
        {message}
        {sub && <span className="mono2">{sub}</span>}
      </div>
    </div>
  )
}
